import React from 'react';
import {Checkbox, Col, Input, message, Modal, Row, Spin} from 'antd';
import {connect} from 'react-redux'
import querystring from "query-string";
import {post_response} from "../../../helper/request";
import '../../../asset/style/settings/manageusers/change_password.css';
import cookie from "react-cookies";
import ForceLogout from "../force_logout";
import {isNull, isTrue} from "../../../utils/utils";
import DownloadPassword from "./download.password";
import PasswordChecklist from "react-password-checklist";

const {Password} = Input;

class ChangePassword extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isFetching: false,
            selectedUserUsername: '',
            oldPassword: '',
            newPassword: '',
            confirmNewPassword: '',
            errorFlag: false,
            errorMessage: '',
            showLogoutModal: false,
            autoGeneratePassword: false,
            autoChangePassword: true,
            allowRetrievePassword: false,
        }
    }

    componentDidMount() {
        const storedModalState = localStorage.getItem('showLogoutModal');
        if (storedModalState) {
            this.setState({showLogoutModal: JSON.parse(storedModalState)});
        }
        document.addEventListener('keydown', this.handleKeyDown);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.selectedUser.id !== this.props.selectedUser.id) {
            this.setState({
                selectedUserUsername: this.props.selectedUser.username,
            })
        }
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKeyDown);
    }

    handleKeyDown = (e) => {
        if (e.key === 'Enter' && this.props.modalVisible) {
            e.preventDefault();
            this.handleOk();
        }
    };

    handleCloseLogoutModal = () => {
        localStorage.setItem("showLogoutModal", "false");
        this.setState({showLogoutModal: false});
    };

    handleOk = () => {
        const complexPasswordCheck = (cookie.load("organisation_setting") || {})["complex_password_check"];
        this.setState({
            isFetching: true,
        });
        if (this.props.changeOwnPassword && this.state.oldPassword.length < 1) {
            this.setState({
                errorFlag: true,
                errorMessage: 'Please enter old password, Compulsory field',
                newPassword: '',
                confirmNewPassword: '',
                isFetching: false,
            });
            return;
        }
        if (this.state.newPassword.length < 8) {
            this.setState({
                errorFlag: true,
                errorMessage: 'Use 8 characters or more for your password.',
                confirmNewPassword: '',
                isFetching: false,
            });
            return;
        } else if (this.state.newPassword !== this.state.confirmNewPassword) {
            this.setState({
                errorFlag: true,
                errorMessage: 'Passwords didn\'t match. Please try again.',
                confirmNewPassword: '',
                isFetching: false,
            });
            return;
        }
        const passwordRegex = /^(?:(?=.*[a-z])(?:(?=.*[A-Z])(?=.*[\d\W])|(?=.*\W)(?=.*\d))|(?=.*\W)(?=.*[A-Z])(?=.*\d)).{8,}$/;
        if (isTrue(complexPasswordCheck) && !passwordRegex.test(this.state.newPassword)) {
            this.setState({
                errorFlag: true,
                errorMessage: 'Password must contain at least one uppercase letter, one lowercase letter, one digit, and one special character.',
                newPassword: '',
                confirmNewPassword: '',
                isFetching: false,
            });
            return;
        }
        let val = {
            username: this.props.selectedUser.username,
            password: this.state.newPassword,
            oldPassword: this.state.oldPassword,
            autoChangePassword: !this.props.changeOwnPassword && this.state.autoChangePassword,
        }
        let url = `/api/update_user_password/`;
        post_response(url, querystring.stringify(val))
            .then(response => {
                if (response.status === 200 || response.status === 301 || response.status === 302) {
                    message.success("Password changed successfully.", 2.5);
                    if (this.props.username === cookie.load('username')) {
                        this.setState({showLogoutModal: true});
                        localStorage.setItem('showLogoutModal', JSON.stringify(true));
                    }
                } else if (response.status === 403 || response.status === 401 || response.status === 400) {
                    message.error("Some error occurred. Not able to change password.", 2.5);
                }
                if ((isNull(this.props.changeOwnPassword) || !this.props.changeOwnPassword) && this.state.autoGeneratePassword) {
                    this.handleAutoGenerate();
                } else {
                    this.handleCancel();
                }
            })
            .catch(err => {
                let msg = err?.response?.data || "Some error occured. Not able to change password."
                message.error(msg, 2.5);
                this.setState({
                    oldPassword: '',
                    newPassword: '',
                    confirmNewPassword: '',
                    isFetching: false,
                    errorFlag: true,
                    errorMessage: msg,
                });
            });
    }

    handleAutoGenerate = () => {
        this.setState({
            isFetching: false,
            errorFlag: false,
            errorMessage: '',
            allowRetrievePassword: true,
        });
    }

    handleCancel = () => {
        this.props.closeModal();
        this.setState({
            autoGeneratePassword: false,
            allowRetrievePassword: false,
            oldPassword: '',
            newPassword: '',
            confirmNewPassword: '',
            isFetching: false,
            errorFlag: false,
            errorMessage: '',
        });
    }

    oldPasswordFieldChange = (e) => {
        this.setState({
            oldPassword: e.target.value,
            errorFlag: false,
            errorMessage: '',
        });
    }

    passwordFieldChange = (e) => {
        this.setState({
            newPassword: e.target.value,
            errorFlag: false,
            errorMessage: '',
        });
    }

    confirmPasswordFieldChange = (e) => {
        this.setState({
            confirmNewPassword: e.target.value,
            errorFlag: false,
            errorMessage: '',
        });
    }

    handleAutoGenerateChange = (e) => {
        if (e.target.checked) {
            const length = 12;
            const lowercaseCharset = "abcdefghijklmnopqrstuvwxyz";
            const uppercaseCharset = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
            const digitCharset = "0123456789";
            const specialCharset = "!@#$%^&*()_+";

            const password =
                lowercaseCharset.charAt(Math.floor(Math.random() * lowercaseCharset.length)) +
                uppercaseCharset.charAt(Math.floor(Math.random() * uppercaseCharset.length)) +
                digitCharset.charAt(Math.floor(Math.random() * digitCharset.length)) +
                specialCharset.charAt(Math.floor(Math.random() * specialCharset.length)) +
                Array.from({length: length - 4}, () => {
                    const charset = lowercaseCharset + uppercaseCharset + digitCharset + specialCharset;
                    return charset.charAt(Math.floor(Math.random() * charset.length))
                }).join('');
            this.setState({
                newPassword: password, confirmNewPassword: password, autoGeneratePassword: true,
                errorFlag: false, errorMessage: ''
            });
        } else {
            this.setState({ newPassword: '', confirmNewPassword: '', autoGeneratePassword: false });
        }
    };


    render() {
        const complexPasswordCheck = (cookie.load("organisation_setting") || {})["complex_password_check"];
        const passwordRegex = /^(?:(?=.*[a-z])(?:(?=.*[A-Z])(?=.*[\d\W])|(?=.*\W)(?=.*\d))|(?=.*\W)(?=.*[A-Z])(?=.*\d)).{8,}$/;
        let passwordDisable = isTrue(complexPasswordCheck) ? !passwordRegex.test(this.state.newPassword) ||
            (this.state.newPassword !== this.state.confirmNewPassword) : false;

        return (
            <>
                <Modal
                    title="Change Password"
                    visible={this.props.modalVisible && !this.state.allowRetrievePassword}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    style={{maxHeight: '400px'}}
                    ref={(modal) => (this.modal = modal)}
                    okButtonProps={{
                        disabled: !(!this.state.errorFlag && this.state.newPassword.length > 0 &&
                            this.state.confirmNewPassword.length > 0) || passwordDisable
                    }}
                >
                    <Spin spinning={this.state.isFetching}>
                        <div>
                            <Row>
                                <Col span={10} className="row-heading">
                                    <b>Username</b>
                                </Col>
                                <Col span={8}>
                                    <Input placeholder="Username" value={this.state.selectedUserUsername}
                                           className="input-field"
                                           autoComplete="off" disabled style={{color: 'black'}}/>
                                </Col>
                            </Row>
                            <br/>
                            {this.props.changeOwnPassword && <>
                                <Row>
                                    <Col span={10} className="row-heading">
                                        <b>Old Password</b>
                                    </Col>
                                    <Col span={8}>
                                        <Password placeholder="Password" value={this.state.oldPassword}
                                                  className="input-field"
                                                  onChange={this.oldPasswordFieldChange} autoComplete="old-password"/>
                                    </Col>
                                </Row>
                                <br/>
                            </>}
                            <Row>
                                <Col span={10} className="row-heading">
                                    <b>New Password</b>
                                </Col>
                                <Col span={14}>
                                    <Password placeholder="Password" value={this.state.newPassword}
                                              className="input-field" disabled={!!this.state.autoGeneratePassword}
                                              onChange={this.passwordFieldChange} autoComplete="new-password"/>
                                </Col>
                            </Row>
                            <br/>
                            <Row>
                                <Col span={10} className="row-heading">
                                    <b>Confirm New Password</b>
                                </Col>
                                <Col span={14}>
                                    <Password placeholder="Confirm Password" value={this.state.confirmNewPassword}
                                              className="input-field" disabled={!!this.state.autoGeneratePassword}
                                              onChange={this.confirmPasswordFieldChange} autoComplete="new-password"/>
                                </Col>
                            </Row>
                            {isTrue((cookie.load("organisation_setting") || {})["complex_password_check"]) &&
                                <Row style={{marginTop: 40}}>
                                    <Col span={24}>
                                        <div className="password-rules" style={{fontStyle: 'italic', height: 160}}>
                                            {this.state.newPassword.length > 0 ?
                                                <PasswordChecklist
                                                    style={{marginLeft: 10}}
                                                    rules={["minLength", "capital", "lowercase", "number", "specialChar", "match"]}
                                                    minLength={8}
                                                    value={this.state.newPassword}
                                                    valueAgain={this.state.confirmNewPassword}
                                                    onChange={(isValid) => {
                                                    }}
                                                /> : <>
                                                    <p>Password must:</p>
                                                    <ul>
                                                        <li>Be 8 to 32 characters long</li>
                                                        <li>Contain at least one uppercase letter</li>
                                                        <li>Contain at least one lowercase letter</li>
                                                        <li>Contain at least one digit</li>
                                                        <li>Contain at least one special character</li>
                                                        <li>Match the Confirm Password</li>
                                                    </ul>
                                                </>
                                            }
                                        </div>
                                    </Col>
                                </Row>}
                            {(isNull(this.props.changeOwnPassword) || !this.props.changeOwnPassword) && <>
                                <br/><br/>
                                <Checkbox checked={this.state.autoGeneratePassword}
                                          onChange={this.handleAutoGenerateChange}>
                                    Auto-generate Password
                                </Checkbox>
                                <div style={{fontSize: 10, marginLeft: 15}}>You will be able to copy and download this
                                    password after changing it
                                </div>
                            </>}
                            {(isNull(this.props.changeOwnPassword) || !this.props.changeOwnPassword) && <>
                                <br/>
                                <Checkbox checked={this.state.autoChangePassword}
                                          onChange={(e) => this.setState({autoChangePassword: e.target.checked})}>
                                    Users must create a new password at next sign-in - Recommended
                                </Checkbox>
                            </>}
                            {this.state.errorFlag ?
                                <div>
                                    <br/>
                                    <Row>
                                        <Col>
                                            <div className="error-message-general"> {this.state.errorMessage} </div>
                                        </Col>
                                    </Row><br/>
                                </div> : <><br/><br/><br/></>
                            }
                        </div>
                    </Spin>
                </Modal>
                <ForceLogout visible={this.state.showLogoutModal} onClose={this.handleCloseLogoutModal}
                             message={'password'}/>
                <DownloadPassword visible={this.state.allowRetrievePassword} onOk={this.handleCancel}
                                  onCancel={this.handleCancel} password={this.state.newPassword}
                                  username={this.state.selectedUserUsername}/>
            </>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        loginStatus: state.loginAlerts.loginStatus,
        urlState: state.searchReducer,
        allSlides: state.slidesReducer
    }
}

export default connect(mapStateToProps)(ChangePassword);
